import React from "react";
import { Route } from "react-router-dom";
import PrivateRoute from "src/routes/PrivateRoute";
import { AssetLibraryPage } from "../pages";

export const routes = (
  <Route
    path="/asset-library"
    element={
      <PrivateRoute>
        <AssetLibraryPage />
      </PrivateRoute>
    }
  />
); 